"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportNotificationDetail = void 0;
var theme_1 = require("../../../components/theme");
var i18n_1 = require("../../../i18n");
var mithril_1 = require("../../../mithril");
var export_notification_detail_style_1 = require("./export.notification.detail.style");
(0, theme_1.addStyles)(export_notification_detail_style_1.Style);
var MessageCodeTranslations = {
    required: i18n_1.T.NOTIFICATION_CODE_REQUIRED,
    default: i18n_1.T.NOTIFICATION_CODE_DEFAULT,
    invalid: i18n_1.T.NOTIFICATION_CODE_INVALID,
    unknown: i18n_1.T.NOTIFICATION_CODE_UNKNOWN,
    other: i18n_1.T.EMPTY,
    reason_only: i18n_1.T.EMPTY
};
function view(ctrl) {
    var messageCode = ctrl.getMessageCode();
    var codeTranslateToken = MessageCodeTranslations[messageCode] || MessageCodeTranslations.UNKNOWN;
    var reasontText = ctrl.getReason();
    //Only states the reasonText
    if (messageCode === 'reason_only') {
        return (0, mithril_1.m)('li', { className: export_notification_detail_style_1.CSS.container }, [
            (0, mithril_1.m)('span', { className: export_notification_detail_style_1.CSS.reason }, reasontText),
            ctrl.hasDefaultValue() ? (0, mithril_1.m)('span', { className: export_notification_detail_style_1.CSS.default }, " (".concat(ctrl.getDefaultValue(), ")")) : null
        ]);
    }
    var reason = ' ' + (0, i18n_1.Translate)(codeTranslateToken);
    if (reasontText) {
        reason = reason + ' - ' + reasontText;
    }
    var fieldPath = ctrl.getFieldPath();
    var useRecursivePath = !ctrl.customizedFieldTitle && fieldPath.length > 0;
    return (0, mithril_1.m)('li', { className: export_notification_detail_style_1.CSS.container }, [
        (0, mithril_1.m)('span', { className: export_notification_detail_style_1.CSS.field }, ctrl.getFieldName()),
        (0, mithril_1.m)('span', { className: export_notification_detail_style_1.CSS.form }, useRecursivePath ? " ".concat((0, i18n_1.Translate)(i18n_1.T.NOTIFICATION_IN, fieldPath.join(' / '))) : null),
        (0, mithril_1.m)('span', { className: export_notification_detail_style_1.CSS.reason }, reason),
        ctrl.hasDefaultValue() ? (0, mithril_1.m)('span', { className: export_notification_detail_style_1.CSS.default }, " (".concat(ctrl.getDefaultValue(), ")")) : null
    ]);
}
exports.ExportNotificationDetail = { view: view };
//# sourceMappingURL=export.notification.detail.js.map